import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { catchError, pluck, retry, tap } from 'rxjs/operators';

interface IGeoIP {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  country_code?: string;
}

/** Used by internation-phone-number.directive */
@Injectable({
  providedIn: 'root'
})
export class GeoIpService {
  public countryCode = null;

  constructor(private readonly http: HttpClient) {}

  public getCountryCode(): Observable<any> {
    if (this.countryCode) {
      return from(this.countryCode);
    }

    return this.http.get<IGeoIP>('https://freegeoip.klokantech.com/json/').pipe(
      retry(3),
      catchError((err) => from([])),
      pluck('country_code'),
      tap((c) => (this.countryCode = c))
    );
  }
}
